import { CommonModule } from '@angular/common';
import { Component, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { PublicService } from '../../../shared/services/public/public.service';

@Component({
  selector: 'app-subscribe',
  standalone: true,
  imports: [CommonModule, InputTextModule,ReactiveFormsModule,ButtonModule],
  templateUrl: './subscribe.component.html',
  styleUrl: './subscribe.component.scss',
  encapsulation: ViewEncapsulation.None,
})
export class SubscribeComponent {
  isSubmitting = false;
  subscribeForm: FormGroup;

  constructor(
    private fb: FormBuilder,
    protected publicService: PublicService,
    private toastr: ToastrService
  ) {
    // Initialize the subscription form with validation
    this.subscribeForm = this.fb.group({
      email: ['', [Validators.required, Validators.email]],
    });
  }

  async onSubmit() {
    if (this.subscribeForm.valid) {
      this.isSubmitting = true; // Disable submission during processing
      const formData = {
        ...this.subscribeForm.value,
        submittedAt: new Date().toISOString(),
      };

      try {
        await this.publicService.subscribeToNewsletter();
        this.toastr.success('Thank you for subscribing!', 'Success');
        this.subscribeForm.reset(); // Reset the form after successful submission
        this.subscribeForm.markAsPristine();
        this.subscribeForm.markAsUntouched();
      } catch (error) {
        console.error('Error during subscription:', error);
        this.toastr.error('An error occurred. Please try again later.', 'Error');
      } finally {
        this.isSubmitting = false; // Re-enable the form
      }
    } else {
      this.toastr.error('Please enter a valid email address.', 'Error');
    }
  }
}

